<template>
  <div class="content" id="content1">
    <div class="mainContent">
      <div class="main">
        <div class="title">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item @click.native="goback">返回</el-breadcrumb-item>
            <el-breadcrumb-item>培训课程</el-breadcrumb-item>
            <el-breadcrumb-item>{{ text }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <el-row :gutter="20">
          <el-col :span="18">
            <div class="video_left">
              <video ref="video" class="video_player" :src="video_url" controls="controls"
                controlslist="nodownload">您的浏览器不支持 video 标签。</video>

              <el-tabs v-model="activeName">
                <el-tab-pane label="课程说明" name="first">
                  <div class="video_content" v-if="curriculumInfo.main_content">
                    <mavon-editor v-model="curriculumInfo.main_content" defaultOpen="preview" :boxShadow="false"
                      :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="附件列表" name="second">
                  <el-table size="small" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
                    <el-table-column prop="file_type" label="类型" width="100px"></el-table-column>
                    <el-table-column prop="title" label="名称"></el-table-column>
                    <el-table-column prop="file_size" label="大小"></el-table-column>
                    <el-table-column prop="download_num" label="下载"></el-table-column>

                    <el-table-column prop="created_time" label="创建时间"></el-table-column>
                    <el-table-column align="center" label="操作">
                      <template slot-scope="scope">
                        <el-button size="small" type="text" @click="download(scope.row)">下载</el-button>
                        <el-button size="small" type="text"
                          v-if="scope.row.file_type != '其他' && scope.row.file_type != 'ai' && scope.row.file_type != 'psd'"
                          @click="preview(scope.row)">预览</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-row :gutter="20" style="margin:20px auto">
                    <el-col :span="12" :offset="10">
                      <el-button type="primary" plain v-if="this.zip_url === '' ? false : true"
                        @click="downloadAll">下载全部</el-button>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="video_right">
              <dl class="choose-dl" v-for="(value, preindex) in selectArr" :key="value.id">
                <dt class="choose-dt">{{ value.title }}</dt>
                <dd class="choose-dd">
                  <div class="choose-item" @click="selectActive(preindex, index, item)"
                    :class="isactive === item.id ? 'addclass' : ''" v-for="(item, index) in value.videoInfoArr"
                    :key="item.id">
                    <div class="curriculum">
                      <i :class="isactive === item.id ? 'el-icon-video-camera-solid' : 'el-icon-video-camera'"></i>
                      {{ item.title }}
                    </div>
                    <div class="time">( {{ item.duration }} )</div>
                  </div>
                </dd>
              </dl>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div
      style="position: fixed; bottom: 15px; right: 30px; width: calc(100% - 260px); z-index: 9999; box-sizing: border-box;">
      <div class="rightBtn" v-if="activeName == 'first'" @click="activeName = 'second'">下 载</div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="50%">
      <el-image :src="url"></el-image>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { getTchTrainInfo } from "@/api/teachingResearchTraining.js";
import {
  trainingInfo,
  trainingDownloadNum
} from "@/api/operationalActivitiesPc.js";

export default {
  data() {
    return {
      activeName: "first",
      tableData: [],
      text: "",
      zip_url: "",
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        htmlcode: true, // 展示html源码
        help: true, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true // 预览
      },

      curriculumInfo: {
        main_content: ""
      },
      isactive: 0,
      run_training_id: "",
      selectArr: [],
      video_url: "",
      dialogVisible: false,
      url: ""
    };
  },
  created() {


    console.log(this.$route.query.id);
    this.run_training_id = this.$route.query.id;
    this.text = this.$route.query.title;
  },
  mounted() {
    document.querySelector("#content1").scrollIntoView(true);
    this.trainingInfo();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    //预览
    preview(row) {
      console.log(row, 56565);
      this.url = row.download_url;

      this.dialogVisible = true;
      // window.open(row.download_url);
    },
    download(row) {
      trainingDownloadNum({
        run_training_file_id: row.id
      }).then(res => {
        console.log(res);
        window.open(row.download_url);

        this.$message.success("下载成功");
        this.trainingInfo();
      });
    },
    downloadAll() {
      window.open(this.zip_url);
    },

    //详情
    trainingInfo() {
      trainingInfo({
        run_training_id: this.run_training_id
      }).then(res => {
        this.zip_url = res.runTrainingInfo.zip_url;

        this.selectArr = res.runTrainingInfo.chapterInfoArr;
        this.curriculumInfo = res.runTrainingInfo;
        this.isactive = this.selectArr[0].videoInfoArr[0].id;
        this.video_url = this.selectArr[0].videoInfoArr[0].video_url;
        this.tableData = res.runTrainingInfo.fileInfoArr;
        console.log(this.zip_url, 565656);
        this.tableData.map(item => {
          if (item.file_type === 100) {
            return (item.file_type = "其他");
          }
          if (item.file_type === 1) {
            return (item.file_type = "png");
          }
          if (item.file_type === 2) {
            return (item.file_type = "jpg/jpeg");
          }
          if (item.file_type === 3) {
            return (item.file_type = "pdf");
          }
          if (item.file_type === 4) {
            return (item.file_type = "doc");
          }
          if (item.file_type === 5) {
            return (item.file_type = "psd");
          }
          if (item.file_type === 6) {
            return (item.file_type = "ai");
          }
        });
      });
    },

    selectActive(preindex, index, item) {
      this.video_url = item.video_url;
      console.log(item, 134);
      this.isactive = item.id;
    }
  }
};
</script>

<style lang="scss" scoped>
.rightBtn {
  margin: 0 auto;
  width: 150px;
  // position: fixed;
  // left: 50%;
  // margin-left: -75px;
  // bottom: 15px;
  padding: 6px 8px;
  border-radius: 7px 7px 7px 7px;
  // z-index: 9999;
  background-color: #1778FF;
  color: #fff;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}

.content {
  width: 100%;
  min-height: 100vh;
  padding: 10px;
  box-sizing: border-box;
}

.title {
  width: 100%;
  background-color: #fff;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  cursor: pointer;
}

.title_left {
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-left: 10px;
}

.mainContent {
  width: 100%;
  // padding: 20px;
  // padding-top: 0;
  box-sizing: border-box;
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
}

.main {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.video_right {
  height: 647px;
  background: #fff;
  color: #1b191b;
  padding: 20px;
  box-sizing: border-box;
}

.video_left {}

.video_left {
  .video_player {
    width: 100%;
    border: 2px solid #dee2e9;
    object-fit: fill;
    margin-top: 20px;
  }
}

// .video_player {
//   width: 100%;
//   height: 453px;
// }
.video_content {
  width: 100%;
  height: auto;
  margin-top: 32px;

  box-sizing: border-box;
}

// .video_player {
//   width: 100%;
//   height: 100%;
//   position: absolute;
// }
// .video_content {
//   width: 100%;
//   padding-bottom: 56.25%;
//   height: 0;
//   position: relative;
//   margin-top: 20px;
// }

/deep/ .el-tree-node__content:hover {
  background: #000;
}

/deep/ .el-menu-item.is-active {
  background-color: #000 !important;
}

/deep/ .el-tree-node:focus>.el-tree-node__content {
  background-color: blue;
}

.addclass {
  font-weight: 700;
  color: #477fd2;
}

.choose-item {
  overflow: hidden;
  width: 100%;
  cursor: pointer;
}

.curriculum {
  float: left;
}

.time {
  float: right;
}

.choose-dt {
  font-size: 16px;
  font-weight: bold;
}

.choose-item {
  padding: 5px 0px;
}
</style>

